import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesWithRoomsListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesWithRoomsListForSelectController.php
* @route '/api/place-with-rooms-for-select/{place_type}'
*/
const GetPlacesWithRoomsListForSelectController = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesWithRoomsListForSelectController.url(args, options),
    method: 'get',
})

GetPlacesWithRoomsListForSelectController.definition = {
    methods: ["get","head"],
    url: '/api/place-with-rooms-for-select/{place_type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesWithRoomsListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesWithRoomsListForSelectController.php
* @route '/api/place-with-rooms-for-select/{place_type}'
*/
GetPlacesWithRoomsListForSelectController.url = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place_type: args }
    }

    if (Array.isArray(args)) {
        args = {
            place_type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place_type: args.place_type,
    }

    return GetPlacesWithRoomsListForSelectController.definition.url
            .replace('{place_type}', parsedArgs.place_type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesWithRoomsListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesWithRoomsListForSelectController.php
* @route '/api/place-with-rooms-for-select/{place_type}'
*/
GetPlacesWithRoomsListForSelectController.get = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlacesWithRoomsListForSelectController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetPlacesWithRoomsListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlacesWithRoomsListForSelectController.php
* @route '/api/place-with-rooms-for-select/{place_type}'
*/
GetPlacesWithRoomsListForSelectController.head = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPlacesWithRoomsListForSelectController.url(args, options),
    method: 'head',
})

export default GetPlacesWithRoomsListForSelectController